import { History } from "history";

let history: History | null = null;

export const setHistory = (historyInstance: any) => {
  history = historyInstance;
};

export const navigateTo = (path: string) => {
  if (history) {
    history.push(path);
  } else {
    console.error("History is not set");
  }
};
